export default function trackPage () {
	window.gtag('send', 'page_view', {
		page_location: window.location.href,
		page_path: window.location.pathname
	});
}